$(->
  # MANAGE > COMPANY > CUSTOMIZE CAREERS PAGES/WIDGET > CAREERS WIDGET > TABLE

  $('#customize_site_template_form').on "ajax:success", ->
    $('body').removeClass('loading')
    $('iframe#site-preview').attr('src', $('iframe#site-preview').attr('src').replace(/site_template_id=(\d+)/,'site_template_id=' + $('#account_site_template_id').val()))
    $('iframe#site-preview')[0].contentWindow.location.reload(true)

  if $('#account-attachments').length > 0
    iFrameResize({}, '#account-attachments')

  $('#layout-tab a').on 'show.bs.tab', ->
    $.ajax
      url: '/manage/attachments/'
      dataType: 'json'
      success: (data)->
        new_options = ""
        $.each data, (i,item)->
          new_options = new_options + '<option value="' + item.id + '">' + item.image_file_name + '</option>'
        $('#layout select.attachment_select').each ->
          old_val = $(this).val()
          $(this).find('option[value!=""]').remove()
          $(this).append(new_options)
          $(this).val(old_val)

  $(document).on 'change', '#widget_brand', ->
    subdomain = $('#widget_brand').val()
    domain = $('#widget_code').data('domain')
    url = "https://#{subdomain}.#{domain}/account?embed=1"
    $('#widget_code').text($('#widget_code').text().replace(/src="[^"]+"/, "src=\"#{url}\""))

  $('#account_site_template_config_client_gtm_id').on('keyup', ->
    this.value = this.value.toUpperCase()
  ).on('blur', ->
    if /^GTM-[A-Z0-9]{1,7}$/.test(this.value) || this.value == ''
      $(this)
        .parent()
        .removeClass('has-error')
      $(this)
        .parent()
        .find('span')
        .html('Add custom Google Tag Manager tracking code here.')
    else
      $(this)
        .parent()
        .addClass('has-error')
      $(this)
        .parent()
        .find('span')
        .html('Please verify the Google Tag Manager ID format')
  )
)
